import React, {useEffect, useMemo} from 'react';
import s from '../../s';
import {observer} from 'mobx-react';
import LevelLockModal from '../modals/level-lock.modal';
import SmartBoxModal from '../modals/smart-box.modal';
import {Portal} from '../../../util';
import {descriptionContent, descriptionFlags, NO_DESCRIPTION_FLAGS, type DescriptionBullet, type DescriptionFlags} from './description-content';

declare const collapse: {
    init: () => void;
};

const bulletBody = (bullet: DescriptionBullet): React.ReactNode => {
    switch (bullet.link) {
        case 'level-lock':
            return (
                <>
                    {bullet.text} <LevelLockModal />
                </>
            );
        case 'smart-box':
            return (
                <>
                    {bullet.text} <SmartBoxModal />
                </>
            );
        case 'create-a-frame':
            return (
                <>
                    {bullet.text} <a href="/frame-designer/design-your-frame/4">Create-a-Frame</a>
                </>
            );
        default:
            return bullet.text;
    }
};

const DescMainContent: React.FC = observer(() => {
    useEffect(() => {
        collapse.init();
    }, []);

    // Decided once, when the section mounts.
    const flags = useMemo((): DescriptionFlags => (s.ready ? descriptionFlags(s.prod, s.ps, s.ui) : NO_DESCRIPTION_FLAGS), []);
    const content = descriptionContent(s.prod, s.si, s.ps, s.ui, Portal, flags, s.currentGradSchoolID);

    return (
        <>
            {content.marketing !== null && (
                <div
                    dangerouslySetInnerHTML={{
                        __html: content.marketing,
                    }}
                />
            )}
            {content.bullets !== null && (
                <ul>
                    {content.bullets.map((bullet, i) => (
                        <li key={i}>{bulletBody(bullet)}</li>
                    ))}
                </ul>
            )}

            {content.overrides !== null && (
                <ul>
                    {content.overrides.map((m, i) => (
                        <li key={i}>{m}</li>
                    ))}
                </ul>
            )}
        </>
    );
});

export default DescMainContent;
